import ClientLayout from "../../../components/client/layout/ClientLayout";
import ClientDocumentTable from "../../../components/client/document/ClientDocumentTable";
import React from "react";

//클라이언트 문서 메인 페이지
const ClientDocumentMainPage: React.FC = () => {
    return (
        <ClientLayout>
            {/*클라이언트 문서 테이블*/}
            <ClientDocumentTable/>
        </ClientLayout>
    )
}
export default ClientDocumentMainPage